import script from "./cancel-trust-dialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./cancel-trust-dialog.vue?vue&type=script&setup=true&lang=ts"

import "./cancel-trust-dialog.vue?vue&type=style&index=0&id=49daa55e&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49daa55e"]])

export default __exports__